import React, { useEffect, useLayoutEffect, useState, useContext } from 'react';
import '../../assets/styles/dashboardpage.css'; // Assuming this is your stylesheet
import { useGetSalesNewsQuery, useGetTagsQuery, useAddTagToCallMutation, useGetFacilitiesQuery } from '../../api/endpoints/apiConfig';
import { useGetFunfactQuery } from '../../api/funfactApi';
import { Button, Link } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { Salesnews } from '../../models/salesnews';
import { Fact } from '../../models/Fact';
import { toast } from 'react-toastify';
import { clearIds } from '../../store/reducers/aircallTagSlice';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { useAppSelector } from '../../hooks/useAppSelector';
import { FacilityContext } from '../../context/FacilityContext';
import { setIsDisposition } from '../../store/reducers/dispositionSlice';
import ConfirmationModal from '../../../src/declaration/Aircall/ConfirmationModal'
import LogRocket from "logrocket";
import {
  clearAllCallIdsSession,
  clearInboundCallsId,
  getCallIdForTagging,
  notifyCallsIdSessionChanged,
} from '../../utils/callsIdSessionSync';

const WaitingPage: React.FC = () => {
  // Use the RTK Query hooks to fetch the data
  const { data: funFact, error: funFactError, isLoading: isFunFactLoading } = useGetFunfactQuery();
  const { data: salesdata, error: salesdataError, isLoading: issalesdataLoading } = useGetSalesNewsQuery();
  const { data: tagsdata } = useGetTagsQuery();
  const [addTagToCall] = useAddTagToCallMutation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [saledatasfetch, setsaledatasfetch] = useState<Salesnews | null>(null);
  const [tester, setTester] = useState<number | null>(null);
  const location = useLocation();
  const selectedOperatorId = sessionStorage.getItem('operatorId');
  const operatorId = selectedOperatorId !== null ? parseInt(selectedOperatorId, 10) : 1;
  const { data: Allfacility } = useGetFacilitiesQuery(operatorId);
  const context = useContext(FacilityContext);
  const isDisposition = useAppSelector((state) => state.disposition.isDisposition);
  // Ensure the context is available
  if (!context) {
    throw new Error('FacilityContext must be used within a FacilityProvider');
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { selectedFacility, setSelectedFacility } = context;

  useLayoutEffect(() => {
    if (location.pathname === '/WaitingPage') {
      clearAllCallIdsSession();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (Allfacility) {
      // Store facilities in session storage
      sessionStorage.setItem("Allfacility", JSON.stringify(Allfacility));
    }
  }, [Allfacility]);
  useEffect(() => {
    if (tagsdata) {
      sessionStorage.setItem('tagsdata', JSON.stringify(tagsdata));
    }
  }, [tagsdata]);

  useEffect(() => {
    const storedTester = sessionStorage.getItem('tester');
    if (storedTester) {
      setTester(Number(storedTester)); // Convert back to number
    }
  }, []);
  useEffect(() => {
    if (salesdata) {
      setsaledatasfetch(salesdata);
    }
  }, [salesdata]);
  useEffect(() => {
    const operatorsData = JSON.parse(sessionStorage.getItem('operators') || '[]');
    if (operatorsData.length > 0) {
      sessionStorage.setItem('operators', JSON.stringify(operatorsData));
    }
  }, []);
  useEffect(() => {
    if (Allfacility) {
      // Store all facilities in session storage
      sessionStorage.setItem('Allfacility', JSON.stringify(Allfacility));
      // Parse setup data from session storage
      const setupData = JSON.parse(sessionStorage.getItem('setupData') || '{}');
      // Validate if setupData and setup array exist
      if (setupData?.setup?.length > 0 && Allfacility?.facilities?.length > 0) {
        // Normalize and map the location codes from setupData
        const setupLocationCodes = setupData.setup.map((facility: any) => facility.location_code);
        // Retrieve the first matching facility based on location_code
        const matchedFacility = setupLocationCodes
          .map((code: string) => {
            return Allfacility.facilities.find(
              (facility: { location_code: string; name: string }) => facility.location_code === code
            );
          })
          .find((facility: undefined) => facility !== undefined); // Find the first non-null facility
        // If a matching facility is found, update sessionStorage and selectedFacility
        if (matchedFacility) {
          const { id, name, location_code } = matchedFacility; // Extract the id and name of the matched facility
          sessionStorage.setItem('matchedFacilityId', id.toString()); // Store facility id
          sessionStorage.setItem('matchedFacilityName', name); // Optionally store facility name
          // Set selected facility with label (name) and id
          setSelectedFacility({ label: `${location_code}-${name}`, id });
        }
      }
    }
  }, [Allfacility, setSelectedFacility]);
  const Nextclick = (mode: string) => {
    LogRocket.startNewSession();
    LogRocket.identify("sales-center-test-page", {
      name:  sessionStorage.getItem("FirstName") + ' ' +  sessionStorage.getItem("LastName"),
      subscriptionType: 'agent'
    });

    if (mode === 'Test') {
      navigate('/TestOperator');
    } else {
      navigate(`/Dashboard/${1}`);
    }
  };
  const Extendtime = () => {
    dispatch(setIsDisposition(!isDisposition));
  }

  const handleConfirm = (isQualified: boolean) => {
    const qualifiedTagName = isQualified ? 'Qualified' : 'Not Qualified';
    // Step 1: Retrieve the callsId and tagsData from sessionStorage
    const callId = getCallIdForTagging();
    const tagsData = sessionStorage.getItem('tagsdata');
    const facilitydatas = sessionStorage.getItem('facilityData');
    const operatordata = sessionStorage.getItem('operators');
    // Step 2: Check if callId and tagsData exist
    if (callId && tagsData) {
      const parsedTagsData = JSON.parse(tagsData);
      const facilityData = facilitydatas ? JSON.parse(facilitydatas) : {};
      const operatordataObject = operatordata ? JSON.parse(operatordata) : {};
      // Find the operator name based on facility operator ID
      const operatorname = operatordataObject.operators.find((operator: { id: number }) => operator.id === facilityData[0]?.operator_id);
      if (!operatorname) {
        console.warn("Operator not found for the given facility operator ID");
        return;
      }
      const operatornames = operatorname.name === 'Store Space Self Storage' ? 'Store Space' : operatorname.name;
      // Find tag details for operator and facility
      const operatortagdetails = parsedTagsData.tags.find((tag: { name: string }) => tag.name === operatornames);
      const facilitytagdetails = parsedTagsData.tags.find((tag: { name: string }) => tag.name === facilityData[0]?.location_code);
      // Find the "Qualified" or "Not Qualified" tag and dispatch to Redux store
      const qualifiedTag = parsedTagsData.tags.find((tag: { id: number, name: string }) => tag.name === qualifiedTagName);
      const idsFromStorage = sessionStorage.getItem('ids');
      const storedIds = idsFromStorage ? JSON.parse(idsFromStorage) : [];
      const updatedIds = [...storedIds, operatortagdetails.id, facilitytagdetails.id, qualifiedTag.id];
      const tagData = { tags: updatedIds };
      addTagToCall({ callId, tagData })
        .unwrap()
        .then(() => {
          toast.dismiss();
          toast.success("Tag added to the call successfully.");
          dispatch(clearIds());
          clearInboundCallsId();
          sessionStorage.removeItem('callsId');
          notifyCallsIdSessionChanged();
          sessionStorage.removeItem('ids');
          //sessionStorage.removeItem('incomingPhones');
        })
        .catch((error) => {
          toast.dismiss();
          if (error.status) {
            // Handle specific HTTP status errors
            switch (error.status) {
              case 400:
                toast.error("Bad request. Please check the tag data.");
                break;
              case 404:
                toast.error("Call not found. Please verify the call ID.");
                break;
              case 500:
                toast.error("Server error. Please try again later.");
                break;
              default:
                toast.error(`Unexpected error occurred: ${error.statusText}`);
            }
          } else if (error.message) {
            // Handle network or JavaScript errors
            toast.error(`An error occurred: ${error.message}`);
          } else {
            // Handle unexpected errors
            toast.error("An unexpected error occurred. Please try again.");
          }
          console.error("Error adding tag to the call:", error);
        });
    } else {
      toast.error("callsId or tagsdata not found.");
    }
  };


  const removeHtmlTags = (text: string | null | undefined): string => {
    if (!text) {
      return ''; // Return an empty string for null or undefined input
    }
    // Decode HTML entities and normalize spaces
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    const decodedText = textArea.value.replace(/\s+/g, ' ').trim();

    return decodedText;
  };

  return (
    <div>
      <main className="dashboard-main">
        {tester === 1 ? (
          <>
            <div style={{ display: 'flex', justifyContent: 'left' }}>
              <Button
                variant="contained"
                color="secondary"
                sx={{ width: '100px' }}
                onClick={() => Nextclick('Test')}
              >
                QA Test Page
              </Button>
            </div>
          </>
        ) : null}

        <section className="header-section">
          <h1>Waiting for an inbound call...</h1>
        </section>
        <section className="fun-fact-section">
          <div className="fun-fact-box">
            <strong>Fun Fact:</strong>{' '}
            {isFunFactLoading ? (
              <span>Loading fun fact...</span>
            ) : funFactError ? (
              <span>Error loading fun fact</span>
            ) : funFact && Array.isArray(funFact) && funFact.length > 0 ? (
              funFact.map((fact: Fact, index: number) => <span key={index}>{fact.fact}</span>)
            ) : (
              <span>No fun fact available</span>
            )}
          </div>
        </section>
        <section className="news-section">
          <h2>Sales Center News</h2>
          <div>
            {issalesdataLoading ? (
              <span>Loading sales news...</span>
            ) : salesdataError ? (
              <span>Error loading sales news</span>
            ) : saledatasfetch && saledatasfetch ? (
              <div
                dangerouslySetInnerHTML={{ __html: removeHtmlTags(saledatasfetch.page_details.news_content) }}
              />
            ) : (
              <span>No sales news available</span>
            )}
          </div>
        </section>
        <ConfirmationModal
          onConfirm={handleConfirm}
        />
      </main>
    </div>
  );
};
export default WaitingPage;
